import React from 'react';

import { connect } from 'react-redux';
import config from '../../config.js';
import { navigateTop } from '../routing/router-utils'; 
import ButtonWithPrice from '../styleguide/ButtonWithPrice';
import DisabledButtonWithReason from '../styleguide/DisabledButtonWithReason';
import PropTypes from 'prop-types';

import styles from './Cart.module.css';

/**
 * Calculate the total product price for checkout
 * 
 * Reconfirm delivery zip codes, minimum order and handle login if needed
 */
const CheckOutButton = ({ 
  dispensaryId,
  dispensaryName,
  dispensaryMap, 
  itemTotal=0,
  minOrderDelivery=0, 
  delivery_address={}, 
  anonymousZipCode,
  closeMenuFn }) => {

  // For temporary pause orders
  // const isOrderingPaused = config.PAUSED_DISPENSARIES.includes(dispensaryId);  
  // Initial browse only mode site-wide
  const isPreviewMode = config.IS_PREVIEW_MODE;

  const [minOrderMet, setMinOrderMet] = React.useState();
  const [isDeliverableZipCode, setIsDeliverableZipCode] = React.useState();        
  const [zip_code, setZipCode] = React.useState();

  React.useEffect(() => {
    if (dispensaryId && dispensaryMap) {
      // const dispensary = dispensaryMap.get(dispensaryId) || {};
      // Minimum order
      setMinOrderMet(itemTotal >= minOrderDelivery); 
      // Delverable zip code
      const newZipCode = delivery_address['zip_code'] || anonymousZipCode;
      if (zip_code !== newZipCode) {
        setZipCode(newZipCode);
        // TODO: re-implement zip code check
        // const dispensaryZipCodes = dispensary.delivery_zip_codes || [];
        // setIsDeliverableZipCode(dispensaryZipCodes.indexOf(newZipCode) > -1); 
        setIsDeliverableZipCode(true);
      }    
    }
  }, [itemTotal, minOrderDelivery, anonymousZipCode, delivery_address, delivery_address.zip_code, dispensaryId, dispensaryMap, setZipCode, zip_code]);
  
  // Format fordisplay
  const minOrder = parseFloat(minOrderDelivery/100).toFixed(2);
  const itemTotalFloat = parseFloat(itemTotal/100).toFixed(2);
  
  const proceedToCheckout = (event) => {
    event.preventDefault();
    // close mobile cart menu
    if ( closeMenuFn ) {
      closeMenuFn(); 
    }
    if (isDeliverableZipCode) {
      navigateTop(`/placeOrder/${dispensaryId}`);
    } 
  };
 
  return(
    <div className={styles.toCheckoutForm}>
      <form>
        { isPreviewMode    // isOrderingPaused
          ? <DisabledButtonWithReason text="Checkout" isFullWidth 
               reason={`DELIVERY LAUNCHING SOON! Zip Run is not currently accepting orders.`} 
               reasonXX={`Online ordering is currently paused for ${dispensaryName}`} 
            /> 
          :  isDeliverableZipCode && minOrderMet
            ? <ButtonWithPrice text="Checkout" price={itemTotalFloat} handleClick={proceedToCheckout} />
            : <>
                <ButtonWithPrice text="Checkout" price={itemTotalFloat} disabled handleClick={(e) => { e.preventDefault() }} />
                <div className={styles.disabledMsg}>
                  { isDeliverableZipCode
                    ? <>
                        <sup className={styles.minOrderSup}>*</sup> 
                        Minimum product order: ${minOrder}
                      </>
                    : <>
                        { zip_code
                           ? <>
                               <sup className={styles.minOrderSup}>*</sup>
                               Delivery not available to {zip_code}
                             </>
                           : <></>
                        }
                      </>
                  }
                </div>
              </>
        }
      </form>
    </div>
  )
}

CheckOutButton.propTypes = {
  dispensaryId: PropTypes.string.isRequired,
  dispensaryName: PropTypes.string.isRequired,
  dispensaryMap: PropTypes.object,
  minOrderDelivery: PropTypes.number.isRequired,
  closeMenuFn: PropTypes.func,
  itemTotal: PropTypes.number.isRequired,
  delivery_address: PropTypes.object,
  anonymousZipCode: PropTypes.string
};

const mapStateToProps = (state)=>{
  return {
    dispensaryMap: state.dispensaryMap,
    itemTotal: state.total,
    delivery_address: state.delivery_address,
    anonymousZipCode: state.anonymous_zip_code
  }
}

export default connect(mapStateToProps)(CheckOutButton)